import { motion } from "framer-motion";
import { Clock, ArrowUpRight } from "lucide-react";
import { BLOGS } from "@/data/content";

export default function Blog() {
  return (
    <section id="blog" data-testid="blog-section" className="section bg-[#F8F9FA]">
      <div className="container-x">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#B31942]/20 bg-white px-3 py-1 text-[12px] font-semibold text-[#B31942]">
              Latest Blogs
            </div>
            <h2 className="mt-4 font-display font-extrabold text-4xl md:text-5xl tracking-tight text-slate-900">
              Insights that keep you <span className="text-[#0A3161]">ahead</span>.
            </h2>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {BLOGS.map((b, i) => (
            <motion.a
              key={b.title}
              href="#"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 3) * 0.06 }}
              onClick={(e) => e.preventDefault()}
              className="group rounded-2xl overflow-hidden bg-white border border-black/5 hover:-translate-y-1 transition-transform soft-shadow hover:soft-shadow-lg"
              data-testid={`blog-${i}`}
            >
              <div className="relative h-48 overflow-hidden">
                <img src={b.img} alt={b.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-white/90 backdrop-blur text-[11px] font-semibold text-[#0A3161]">{b.tag}</span>
              </div>
              <div className="p-5">
                <h3 className="font-display text-lg font-bold text-slate-900 leading-snug group-hover:text-[#0A3161] transition-colors">
                  {b.title}
                </h3>
                <div className="mt-3 flex items-center justify-between text-xs text-slate-500">
                  <span>{b.date}</span>
                  <span className="inline-flex items-center gap-1"><Clock className="h-3 w-3" /> {b.read}</span>
                  <ArrowUpRight className="h-4 w-4 text-slate-400 group-hover:text-[#B31942] transition-colors" />
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
